import {useTranslation} from 'react-i18next';
import {SVG} from '../../../../../../constants/assetLists';

type Props = {
  questionTitle: string;
  currentIndex: number;
  totalQuestions: number;
  totalResponders: number;
  showTotalResponders?: boolean;
  onPrev: () => void;
  onNext: () => void;
};

function QuestionNavigator({
  questionTitle,
  currentIndex,
  totalQuestions,
  totalResponders,
  showTotalResponders,
  onPrev,
  onNext,
}: Props) {
  const {t} = useTranslation();

  const isFirst = currentIndex === 0;
  const isLast = currentIndex === totalQuestions - 1;

  return (
    <div className="flex flex-col gap-2 mt-4 flex-shrink-0">
      {/* Question title row with navigation */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1">
          <button
            type="button"
            onClick={onNext}
            disabled={isLast}
            className={`w-6 h-6 rounded-[4px] bg-gray90 border-[1px] border-gray flex items-center justify-center ${isLast && 'cursor-not-allowed opacity-60'}`}>
            <img
              src={SVG.nextBlackIcon}
              alt="next icon"
              className="w-[5px] h-[10px] object-contain"
            />
          </button>

          <span className="text-xl font-bold text-darkerGray w-[70px] text-center">
            {currentIndex + 1}/{totalQuestions}
          </span>

          <button
            type="button"
            onClick={onPrev}
            disabled={isFirst}
            className={`w-6 h-6 rounded-[4px] bg-gray90 border-[1px] border-gray flex items-center justify-center ${isFirst && 'cursor-not-allowed opacity-60'}`}>
            <img
              src={SVG.prevBlackIcon}
              alt="prev icon"
              className="w-[5px] h-[10px] object-contain"
            />
          </button>
        </div>

        <h3 className="text-xl font-bold text-darkerGray">{questionTitle}</h3>
      </div>

      {/* Responder count */}
      {showTotalResponders && (
        <div className="flex">
          <span className="text-black">
            {totalResponders} {t('forms.dialog.responses.responders')}
          </span>
        </div>
      )}
    </div>
  );
}

export default QuestionNavigator;
